
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'teszt',
	'visualizationSlideoutTitle': 'Megjelenítések',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Adjon meg egy számot',
	'maxValuePlaceholder': 'Adjon meg egy számot',
	'customRangeErrorMessage': 'Az értéknek számnak kell lennie',
	'propFillColor': 'Kitöltés színe',
	'propBorderColor': 'Szegélyszín',
	'propColorPalette': 'Aktuális színpaletta',
	'propColorPaletteChangeLabel': 'Színpaletta módosítása',
	'propNewColorPaletteLabel': 'Egyéni színpaletta létrehozása',
	'propNewHeatPaletteLabel': 'Egyéni hőpaletta létrehozása',
	'propDonutRadius': 'Fánk sugara',
	'showTitleLabel': 'Cím megjelenítése',
	'titleTypeLabel': 'Cím típusa',
	'smartTitleLabel': 'Intelligens cím',
	'customTitleLabel': 'Egyéni cím',
	'noTitleLabel': 'Nincs cím',
	'propHeatScalePalette': 'Aktuális hőpaletta',
	'propHeatPaletteChangeLabel': 'Hőpaletta módosítása',
	'propMaintainAxisScales': 'Tengelylépték megtartása',
	'propLineAndSymbolColor': 'Vonal és szimbólum színe',
	'propLineAndSymbolPalette': 'Vonal és szimbólum színpaletta',
	'propElementColor': 'Elem színe',
	'propColumnColor': 'Oszlop színe',
	'propColumnPalette': 'Oszlop színpalettája',
	'propColumnHeatPalette': 'Oszlop hőpaletta',
	'propBarColor': 'Sáv színe',
	'propGoalColor': 'Cél színe',
	'propToColor': 'Színre',
	'propFromColor': 'Színről',
	'propNumberValidationErrorMessageId': 'Adjon meg egy számot',
	'fontSizeAuto': 'Automatikus',
	'propAutoBinCount': 'Csoportok száma',
	'propAutoBinToggle': 'Automatikus csoportosítás',
	'tabName_general': 'Általános',
	'tabName_visDetails': 'Részletek',
	'tabName_animation': 'Animáció',
	'tabName_mediaDetails': 'Médiatartalom részletei',
	'tabName_webDetails': 'Weblap részletei',
	'tabName_imageDetails': 'Kép részletei',
	'tabName_visualization': 'Megjelenítés',
	'tabName_text': 'Szöveg',
	'sectionName_colorsAndThemes': 'Szín és témák',
	'sectionName_appearance': 'Megjelenés',
	'sectionName_general': 'Általános',
	'sectionName_colorPalette': 'Színes',
	'sectionName_axis': 'Tengely',
	'sectionName_axis_label': 'Tengely',
	'sectionName_legend': 'Jelmagyarázat',
	'sectionName_chart': 'Diagram',
	'sectionName_regionLayer': 'Régiók réteg',
	'sectionName_pointLayer': 'Pontok réteg',
	'sectionName_latLongLayer': 'Földrajzi szélesség/földrajzi hosszúság réteg',
	'sectionName_pathLayer': 'Útvonalréteg',
	'propTransparencyDescription': 'Az átlátszóság növelése vagy csökkentése. Adjon meg egy 0 és 100 közötti értéket',
	'smart_annotation_unauthorized': 'Jegyzetek: jogosulatlan hozzáférés',
	'smart_annotation_method': 'Jegyzetek: a metódus nem engedélyezett',
	'smart_annotation_media': 'Jegyzetek: az adathordozó típusa nem engedélyezett',
	'smart_annotation_input': 'Jegyzetek: a bemenet érvénytelen',
	'smart_annotation_internal': 'Jegyzetek: belső rendszerhiba',
	'smart_annotation_generic_error': 'Jegyzetek: szolgáltatáshiba',
	'smart_annotation_dialog_title': 'Insights',
	'smart_errors': 'Szövegmagyarázat hibák:',
	'smart_warnings': 'Szövegmagyarázat figyelmeztetések:',
	'smart_annotation_insight_icon_title': 'Ismeretek',
	'smart_annotations_toggle_on': 'Insights bekapcsolása',
	'smart_annotations_toggle_off': 'Insights kikapcsolása',
	'smart_annotation_insight_unavailable': 'A betekintések jelenleg nem elérhetők',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Első vagy utolsó % szűrő alkalmazása esetén nem állnak rendelkezésre betekintések',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Első vagy utolsó % szűrő alkalmazása esetén nem áll rendelkezésre előrejelzés',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Első vagy utolsó szűrő alkalmazása, illetve ha a mezőben egynél több oszlop van, nem állnak rendelkezésre betekintések',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Első vagy utolsó szűrő alkalmazása, illetve ha a mezőben egynél több oszlop van, nem áll rendelkezésre előrejelzés',
	'forecast_title': 'Előrejelzés',
	'forecast_toggle_on': 'Előrejelzés bekapcsolása',
	'forecast_toggle_off': 'Előrejelzés kikapcsolása',
	'statDetailsPerspectiveTitle': 'Elemzés',
	'emptyStatDetailsPanel': 'Az aktuális megjelenítéshez nem áll rendelkezésre további elemzés.',
	'predict_errors': 'Elemzési hibák',
	'predict_warnings': 'Elemzés figyelmeztetései',
	'fpd_invalid_data_source': 'Ez az adatforrás nem rendelkezik társított intelligens modullal',
	'fpd_network_issue': 'Probléma merült fel az futtatásakor ezen az adatforráson',
	'fpd_data_source_category': 'Az intelligens modul hiányzik',
	'fpd_response_errors': 'Javasolt tényező hibái',
	'fpd_response_warnings': 'Javasolt tényező figyelmeztetései',
	'catalyst_service_bad_request': 'Helytelen kérés',
	'catalyst_service_unkown_Id': 'Ismeretlen kérésazonosító található',
	'catalyst_service_internal_server_error': 'Belső kiszolgáló hiba',
	'catalyst_service_generic_error': 'Catalyst szolgáltatás hiba',
	'catalyst_service_error': 'Ez a szolgáltatás jelenleg nem áll rendelkezésre',
	'propLegendPosition': 'Jelmagyarázat pozíciója',
	'propLeft': 'Bal',
	'propRight': 'Jobb',
	'propTop': 'Leggyakoribb',
	'propBottom': 'Alsó',
	'propNone': 'Nincs',
	'propLegendDisplay': 'Jelmagyarázat megjelenítése',
	'targetThicknessPlaceHolder': '%{min} - %{max}',
	'targetThicknessErrorMsg': 'Írjon be egy %{min} és %{max} közé eső egész számot.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Tényezők (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'kijelölt)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Visszaállítás az alapértelmezett értékekre',
	'possibelKeyDriver_AddNewDrivers': 'További tényezők hozzáadása',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'További tényezők hozzáadása kereséssel',
	'possibleKeyDrivers_MaxPossibleReached': 'Néhány hozzáadandó tényező kijelölésének megszüntetése vagy mások kijelölése',
	'possibleKeyDrivers_Recommended': 'Javasolt',
	'visRecommendedTypes': 'Javasolt megjelenítési típusok',
	'visRecommender_smartsfailure': 'A megjelenítési ajánlások jelenleg nem érhetők el',
	'visMore': 'További...',
	'visMoreTooltip': 'További megjelenítések',
	'visOtherTypes': 'Egyéb megjelenítési típusok',
	'visChange': 'Megjelenítés módosítása',
	'automaticTypeCaption': 'Automatikus',
	'propVisType': 'Megjelenítési típusok',
	'dlg_loading': 'Betöltés...',
	'snippetListChartCaption': 'Kódrészlet lista',
	'convoClusterChartCaption': 'Párbeszédfürt',
	'areaChartCaption': 'Terület',
	'barChartCaption': 'Sáv',
	'columnChartCaption': 'Oszlop',
	'stackedbarChartCaption': 'Halmozott sáv',
	'stackedcolumnChartCaption': 'Halmozott oszlop',
	'bubbleChartCaption': 'Buborék',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Tényezőelemzés',
	'scatterChartCaption': 'Szórás',
	'lineChartCaption': 'Vonal',
	'pointChartCaption': 'Pont',
	'heatChartCaption': 'Hőtérkép',
	'bulletChartCaption': 'Felsorolásjel',
	'waterfallChartCaption': 'Vízesés',
	'pieChartCaption': 'Torta',
	'mapChartCaption': 'Térkép',
	'radialBarChartCaption': 'Radiális',
	'compositeChartCaption': 'Vonal és oszlop',
	'wordCloudChartCaption': 'Szófelhő',
	'networkChartCaption': 'Hálózat',
	'relationshipNetworkChartCaption': 'Viszonyhálózat',
	'treemapChartCaption': 'Fatérkép',
	'packedBubbleChartCaption': 'Zárt buborék',
	'hierarcicalPackedBubbleChartCaption': 'Hierarchia buborék',
	'spiralChartCaption': 'Spirál',
	'decisionTreeChartCaption': 'Döntési fa',
	'legacyMapChartCaption': 'Örökölt térkép',
	'sunburstChartCaption': 'Napsugár',
	'visUsageComparison': 'Összehasonlítás',
	'visUsageRelationships': 'Kapcsolatok',
	'visUsageTrend': 'Trend',
	'visUsagePartsToWhole': 'Részek - egész',
	'visUsageGeospatial': 'Térinformatikai',
	'visUsageAdvanced': 'Speciális elemzések',
	'visUsageTablesAndSummary': 'Táblák és összegzés',
	'visUsageSocialInsights': 'Közösségi betekintések',
	'visUsageOther': 'Egyéb',
	'autoBinActionText': 'Automatikus csoportosítás',
	'filterAutobinActionText': 'Tároló szűrése',
	'memberCalculationActionText': 'Tag számítás',
	'toolbarActionCalculation': 'Számítás',
	'toolbarActionEditCalculation': 'Számítás szerkesztése',
	'topBottomRankLabel': '(%{label}) rangsor',
	'toolbarDeleteFilterActionText': 'Szűrő eltávolítása',
	'toolbarActionTopKeyDrivers': 'Tényezők megjelenítése',
	'toolbarActionCustomGroup': 'Egyéni csoport',
	'canNotCreateCustomGroup': 'Ez az egyéni csoport nem hozható létre.',
	'aria_label_datatable': 'Adattábla',
	'summaryCaption': 'Összegzés',
	'MeasuresCaption': 'Mérőszámok',
	'MeasuresGroupCaption': 'Mérőszámcsoport (%{count})',
	'ValuesCaption': 'Értékek',
	'turnInsightsOn': 'Insights bekapcsolása',
	'turnInsightsOff': 'Insights kikapcsolása',
	'decisionRules': 'Szabályok',
	'decisionTree': 'Fadiagram',
	'decisionSunburst': 'Fa napsugár',
	'switchToDecisionRules': 'Váltás döntési szabályokra',
	'switchToDecisionTree': 'Váltás döntési fára',
	'data_group_less_then': 'kisebb, mint %{rangeTo}',
	'data_group_to': '%{rangeFrom} - < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} és felette',
	'nullValueContent': '(nincs érték)',
	'sum': 'Összeg',
	'count': 'Darabszám',
	'countdistinct': 'Egyedi darabszám',
	'avg': 'Átlag',
	'min': 'Minimális',
	'max': 'Maximális',
	'automatic': 'Egyéni',
	'variance': 'Variancia',
	'stddev': 'Szórás',
	'median': 'Medián',
	'calculated': 'Számított',
	'none': 'Nincs',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'unSupportedPromptType': 'Az adatkérési forgatókönyv jelenleg nem támogatott.',
	'preAggregateLabel': 'Adatkérési értékek alkalmazása az adatforrásból',
	'postAggregateLabel': 'A jelentésben lévő adatkérési értékek alkalmazása',
	'preAggregateText': 'A tartomány az adatforrásban szereplő értékeket használja, nem a műszerfalon megjelenített értékeket.',
	'defaultAggregation_count': 'Darabszám',
	'defaultAggregation_countdistinct': 'Egyedi darabszám',
	'defaultAggregation_max': 'Maximális',
	'defaultAggregation_min': 'Minimális',
	'defaultAggregation_avg': 'Átlag',
	'defaultAggregation_sum': 'Összeg',
	'defaultAggregation_auto': 'Automatikus (%{aggregationType})',
	'keydriver_average': 'Teljes átlag',
	'keydriver_up_down': 'A kiemelt csoportok magas vagy alacsony átlagaikkal nagyobb hatást gyakorolnak a célra. A szokatlanul magas vagy alacsony átlagú csoportok gyakorolják a legerősebb hatást.',
	'keydriver_different': 'A kiemelt csoportok eloszlása jelentősen különbözik a teljes eloszlástól. Ezek a csoportok erősebb hatással vannak a célra.',
	'topOperator': 'Leggyakoribb',
	'bottomOperator': 'Alsó',
	'topBottomFact': '%{operator} %{value}%{percent} %{columnLabel} szerint',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Az első vagy az utolsó elemek számának törlése',
	'deleteTopBottomPercent': 'Az első vagy az utolsó elemek százalékának törlése',
	'topBottomTitle': 'Csak ez az objektum',
	'deleteTopBottom': 'Az első vagy az utolsó elemek számának törlése',
	'editTopBottom': 'Az első vagy az utolsó elemek számának szerkesztése',
	'editTopBottomCount': 'Az első vagy az utolsó elemek számának szerkesztése',
	'editTopBottomPercent': 'Az első vagy az utolsó elemek százalékának szerkesztése',
	'ariaDeleteTopBottomCountLabel': 'Az első vagy az utolsó elemek számának törléséhez nyomja le a DELETE billentyűt.',
	'ariaDeleteTopBottomPercentLabel': 'Az első vagy az utolsó elemek százalékának törléséhez nyomja le a DELETE billentyűt.',
	'ariaEditTopBottomCountLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaEditTopBottomPercentLabel': 'Az első vagy az utolsó elemek százalékának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteDrillStateLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'drillUpStateTitle': 'Felfúrás',
	'drillDownStateTitle': 'Lefúrás',
	'ariaEditTopBottomLabel': 'Az első vagy az utolsó elemek számának szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteTopBottomLabel': 'Az első vagy az utolsó elemek számának törléséhez nyomja le a DELETE billentyűt.',
	'allKeyDriversLabel': 'Automatikus (minden tényező)',
	'filter_drag_and_drop_single_dock': 'Húzza ide az adatokat a szűréshez.',
	'filter_drag_and_drop_all_tabs': 'Húzza ide az adatokat az összes lapon történő szűréshez.',
	'filter_drag_and_drop_current_tab': 'Húzza ide az adatokat az aktuális lapon történő szűréshez.',
	'filter_empty_consume_mode': 'Nincs alkalmazva szűrő.',
	'filterClearAllItems': 'Összes szűrő kiürítése',
	'filterDeleteAllItems': 'Összes szűrő törlése',
	'filterDockChevronLeft': 'Adatok görgetése',
	'filterDockChevronRight': 'Adatok görgetése',
	'filterIconLabel_Single': 'Szűrők',
	'filterIconLabel_Global': 'Minden lap',
	'filterIconLabel_Tab': 'Ez a lap',
	'filterIconTooltip_Single': 'Szűrők',
	'filterIconTooltip_Global': 'Összes lapra vonatkozó szűrők',
	'filterIconTooltip_Tab': 'Adott lapra vonatkozó szűrők',
	'filterDropZoneTooltip_Single': 'Szűrő lerakási zóna',
	'filterDropZoneTooltip_Global': 'Összes lapra vonatkozó szűrő lerakási zóna',
	'filterDropZoneTooltip_Tab': 'Adott lapra vonatkozó szűrő lerakási zóna',
	'filterOverflowMenu': 'Továbbiak',
	'expand': 'Kibontás',
	'collapse': 'Visszazárás',
	'filterDockItemNameAriaLabel': 'Nyomja le az Entert a szűrő párbeszédablak elindításához, és adja meg a szűrést.',
	'filterItemCanvasMove': 'Hozzáadás a vászonhoz',
	'filterItemDelete': 'Szűrő törlése',
	'filterInvertRange': 'összes, kivéve: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Nem %{from} után',
	'filter_date_after': '%{from} után',
	'filter_date_before_except': 'Nem %{to} előtt',
	'filter_date_before': '%{to} előtt',
	'filter_date_between_except': 'Nem %{from} és %{to} között',
	'filter_date_between': '%{from} és %{to} között',
	'filterValueSeparator': ',',
	'filterAll': 'Mind',
	'filterExcept': 'kivéve: %{values}',
	'filterDockToolbarButtonLabel': 'Szűrődokk',
	'navigateTitle': 'Navigálás ide:',
	'current_nav_group': 'Aktuális navigációs csoport: %{navigation_group_name}',
	'next': 'Tovább',
	'previous': 'Előző',
	'multiselectMsg': '%{count} kiválasztva',
	'errMsgFilterItemMissingTitle': 'A(z) %{itemName} szűrőérték nem tölthető be mert az adathalmazhoz nem állnak rendelkezésre ezek az értékek',
	'errMsgFilterItemGenericTitle': 'A szűrőértékek nem tölthetők be',
	'textFilterItemsNotFound': 'Nincs elérhető elem.',
	'nullValueLabel': '(üres)',
	'filterConditionLabel': 'Szűrési feltétel',
	'filter_includesAll': 'Összes tartalmazása',
	'filter_allMembersOfSet': 'A halmaz összes tagja',
	'modelFilter': 'Szűrő',
	'filtersTitle': 'Szűrő tulajdonságok',
	'search': 'Keresés',
	'clearTextFilterValue': 'Törlés',
	'invertFilterSelection': 'Megfordítás',
	'modellingLoading': 'Betöltés...',
	'searchAll': 'Összes oszlop megkeresése',
	'toolbarActionPossibleKeyDrivers': 'Hatókör szerkesztése',
	'toolbarActionPossibleKeyDriversSubTitle': 'A tényezőelemzés diagramon történő figyelembevételhez húzzon ide elemeket a bal oldalról',
	'toolbarActionSort': 'Rendezés',
	'toolbarActionSortAscending': 'Növekvő sorrendbe rendezés',
	'toolbarActionSortDescending': 'Csökkenő sorrendbe rendezés',
	'toolbarActionSortAuto': 'Automatikus (%{sortOrder})',
	'toolbarActionSortCustom': 'Egyéni',
	'toolbarActionFormat': 'Formátum',
	'toolbarActionFormatAbbreviation': 'Rövidítés',
	'toolbarActionFormatNone': 'Automatikus',
	'toolbarActionFilter': 'Szűrő',
	'toolbarActionTopBottom': 'Felső vagy alsó',
	'toolbarActionRmvShape': 'Alakzat eltávolítása',
	'toolbarActionToggleShapeDrop': 'Infografika alakja',
	'toolbarActionToggleShapeDropTitle': 'Infografika létrehozása',
	'toolbarActionToggleShapeDropText': 'Húzzon egy alakot erre a mezőre az infografika létrehozásához.',
	'toolbarActionAggregationType': 'Összegzés',
	'toolbarDeleteActionText': 'Oszlop eltávolítása',
	'toolbarTextActionText': 'Szöveg formázása',
	'toolbarActionFilterLocalKeepSelected': 'Megtartás',
	'toolbarActionFilterLocalExcludeSelected': 'Kizárás',
	'toolbarActionFilterAllKeepSelected': 'Szűrő',
	'toolbarActionSimpleCalculation': 'Egyszerű számítás',
	'toolbarActionDrillBack': 'Vissza',
	'toolbarActionDrillUp': 'Felfúrás',
	'toolbarActionDrillDown': 'Lefúrás',
	'toolbarActionNavigate': 'Navigálás',
	'toolbarActionCreateFilterGroup': 'Új kapcsolat létrehozása',
	'toolbarActionDisconnectFilterGroup': 'Összes hivatkozás megszüntetése',
	'toolbarActionLinkFilterGroup': 'Hozzáadás meglévő kapcsolathoz',
	'toolbarActionLassoSelect': 'Eszköz kiválasztása',
	'toolbarActionRefreshDeveloperWidget': 'Frissítés',
	'textFontFamilySubClassHairline': 'Hajszálvonal',
	'textFontFamilySubClassThin': 'Vékony',
	'textFontFamilySubClassThinItalic': 'Vékony dőlt',
	'textFontFamilySubClassExtraLight': 'Extra könnyű',
	'textFontFamilySubClassExtraLightItalic': 'Extra könnyű dőlt',
	'textFontFamilySubClassLight': 'Világos',
	'textFontFamilySubClassLightItalic': 'Könnyű dőlt',
	'textFontFamilySubClassRegular': 'Normál',
	'textFontFamilySubClassRegularItalic': 'Normál dőlt',
	'textFontFamilySubClassItalic': 'Dőlt',
	'textFontFamilySubClassMedium': 'Közepes',
	'textFontFamilySubClassMediumItalic': 'Közepes dőlt',
	'textFontFamilySubClassHeavy': 'Nehéz',
	'textFontFamilySubClassHeavyItalic': 'Nehéz dőlt',
	'textFontFamilySubClassDemiBold': 'Középkövér',
	'textFontFamilySubClassDemiBoldItalic': 'Középkövér dőlt',
	'textFontFamilySubClassBold': 'Félkövér',
	'textFontFamilySubClassBoldItalic': 'Kövér dőlt',
	'textFontFamilySubClassExtraBold': 'Extra kövér',
	'textFontFamilySubClassExtraBoldItalic': 'Extra kövér dőlt',
	'textFontFamilySubClassBlack': 'Fekete',
	'textFontFamilySubClassBlackItalic': 'Fekete dőlt',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'növekvő',
	'dlg_descending': 'csökkenő',
	'dlg_custom': 'egyéni',
	'dlg_none': 'nincs',
	'dlg_hierarchy': 'hierarchia',
	'dlg_namedSet': 'nevesített készlet',
	'dlg_rank': 'rank',
	'remove_slider_handle': 'Fogó eltávolítása',
	'visualizationLabel': 'Megjelenítés',
	'chartLabel': '%{chartName} diagram',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Az eszközelemen belüli navigáláshoz nyomja le az F12 billentyűt',
	'f10KeyDescription': 'Az eszközelem fókusznézetének indításához nyomja le az F10 billentyűt',
	'playButtonLabel': 'Lejátszás',
	'dataPlayerValueListLabel': 'Adatlejátszó értékei',
	'localFilterTitle': 'Csak ez az objektum',
	'globalFilterTitle': 'Minden objektum',
	'deleteFilter': 'Szűrő törlése',
	'editFilter': 'Szűrő szerkesztése',
	'ariaEditFilterLabel': 'A szűrő szerkesztéséhez nyomja le az ENTER billentyűt.',
	'ariaDeleteFilterLabel': 'A szűrő törléséhez nyomja le a DELETE billentyűt.',
	'measureFilterBetween': '%{lowerBound} és %{upperBound} között',
	'measureFilterNotBetween': 'Nem %{lowerBound} és %{upperBound} között',
	'dimFilterIn': 'Tartalmazza: %{in}',
	'dimFilterNotIn': 'Nem tartalmazza: %{out}',
	'gtFilter': '%{lowerBound} után',
	'ltFilter': '%{upperBound} előtt',
	'ariaEditPrompt': 'Az adatkérési érték megváltoztatásához nyomja le az ENTER billentyűt.',
	'dataPointFilterTitle': 'Adatpontok',
	'dataPointFilterIncludeSummary': '%{valueCount} adatpontot tartalmaz',
	'dataPointFilterExcludeSummary': '%{valueCount} adatpontot nem tartalmaz',
	'widgetFiltersLabel': 'Eszközelemszűrők',
	'coachMarkTitleSpiralTarget': 'Hatókör szerkesztése',
	'coachMarkContentSpiralTarget': 'Itt érheti el és módosíthatja a célhoz kijelölt tényezőket.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Ismeretlen helyek:',
	'geomapAmbiguousLocations': 'Nem egyértelmű régiók',
	'visualizationNotifications': 'Megjelenítési értesítések:',
	'dataNotifications': 'Adatokra vonatkozó értesítések:',
	'autobinSuggestion': 'Automatikus csoportosítás bekapcsolása',
	'LIVE_empty_visualization_hint_title': 'Állítsa össze a megjelenítést',
	'LIVE_empty_visualization_hint_description': 'Húzza az adatokat ide vagy a mezőkre.',
	'LIVE_slots_required_field_description': '%{asterisk} Kötelező mezőt jelöl',
	'LIVE_slots_drag_and_drop_description': 'Húzza az adatokat a fenti mezőkre a megjelenítés összeállításához és szűréséhez.',
	'dwErrorLoadingAvailableVisualizations': 'Az elérhető megjelenítési meghatározásokat nem lehet betölteni',
	'moreDataIndicator': 'Az adatok le lettek vágva %{threshold} elemnél. Alkalmazzon szűrőt kevesebb elem megjelenítéséhez.',
	'nonCtxTopBottomInvalid': 'Kontextus nélküli alsó/felső szabály meghatározása nem támogatott a kereszttáblák esetében. Eltávolításra került a kereszttábla nézetből.  Definiálja át a szabályt legalább egy kategórián a(z) %{columnName} kontextusában.',
	'dwErrorLoadingVisualizationNotFound': 'Az objektumot nem\' lehet betölteni, mert hiányzik belőle egy megjelenítési meghatározás.',
	'dwErrorLoadingVisualizationListNotFound': 'Nem\' lehet betölteni a megjelenítést.',
	'dwErrorRunningQuery': 'Nem\' lehet lekérni az adatokat a(z) %{datasetName} adathalmazból.',
	'dwErrorGeoData': 'Probléma\' merült fel a földrajzi adatok térképen történő megjelenítése során. Válasszon egy másik megjelenítési típust.',
	'dwPromptSignonCancelWarning': 'A megjelenítéshez tartozó adatok nem érhetők el. Adja meg a megfelelő hitelesítő adatokat.',
	'dwErrorMissingDataset': 'Nem\' lehet betölteni a megjelenítést, mert a társított \'%{datasetName}\' adathalmaz nem\' érhető el.',
	'dwErrorRenderingVisualization': 'Nem\' lehet betölteni a megjelenítést.',
	'dwErrorVisualizationTooSmall': 'A megjelenítés túl kicsi, így nem jeleníthetők meg a benne lévő adatok. Nagyítsa a megjelenítést vagy korlátozza a benne tárolt adatokat.',
	'errorSourceNotFound': 'A megjelenítést nem lehet betölteni, mert a hozzá társított \'%{sourceName}\' forrás nem érhető el.',
	'errorActionNotSupported': 'Ez a művelet nem támogatott a(z) \'%{sourceName}\' adatforrás esetén.',
	'errorMeasureNotSupportedOnMultiEdges': 'A megjelenítés több szélén is rendelkezik mérőszámokkal, ami már nem támogatott. Helyezze a mérőszámokat egyetlen szélre.',
	'errorExceedAllowableValue': 'A cellák becsült száma meghaladja a megengedett értéket (100000). A tervezett halmazokra szűrést alkalmazva csökkentse a cellák számát.',
	'propScaleLabel': 'Ikonok mennyisége',
	'propScaleDescription': 'Válassza ki az ikonok mennyiségét',
	'propScaleFew': 'Alsó',
	'propScaleDefault': 'Alapértelmezett',
	'propScaleMany': 'Felső',
	'lastRefresh': 'Utolsó frissítés ennyivel ezelőtt: %{timeInterval}',
	'widgetTimer': 'Eszközelem időmérője',
	'datasetItemsUnavailable': 'Az ebben a megjelenítésben használt egyes adathalmazelemek nem érhetők el.',
	'datasetItemUnavailable': 'Ez az adathalmazelem nem érhető el',
	'retry': 'Újra próbálkozás',
	'widgetConditionalFormatLabel': 'Feltételes formátum vezérlőinek váltása',
	'widgetConditionalFormatTitle': 'Feltételes formázás színének szerkesztése',
	'conditionalPalettePickerLabel': '%{title} értékek eloszlása',
	'HistogramYAxisTitle': 'Darabszám',
	'crosstabName': 'Kereszttábla',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'n.a.',
	'summaryLabel': '%{label} %{value} értékkel',
	'infographicLabel': '%{label} %{value} értékkel',
	'warning': 'Figyelmeztetés',
	'swapRowsAndColumns': 'Sorok és oszlopok felcserélése',
	'hideSummariesLabel': 'Összegzések elrejtése',
	'showSummariesLabel': 'Összegzések megjelenítése',
	'hideRowColumn': 'Elrejtés',
	'showAllRowColumn': 'Összes megjelenítése',
	'dataAssetPropertiesLabel': 'Megjelenítési tulajdonságok',
	'evAdd': 'Oszlop hozzáadása',
	'evCollapse': 'Visszazárás',
	'evColumns': 'Oszlopok',
	'evLocalFilters': 'Helyi szűrők',
	'evExpand': 'Kibontás',
	'evFilterTooltip': 'Szűrő',
	'missingColumn': 'A következő hiányzik: %{columnLabel}',
	'missingFiltering': 'Hiányzó oszlopszűrők:',
	'missingDataItem': 'A hivatkozott adatelem (\'%{dataItemId}\') nem található a felületi elemben.',
	'heatByLabel': 'Intenzitás e szerint:',
	'toolbarChangeVisualization': 'Megjelenítés módosítása',
	'modellingRelatedTablesNoneFound': 'Nincs kapcsolódó tábla',
	'processing': 'Feldolgozás...',
	'errorCellWarning': 'Néhány összegzett értéket nem sikerült kiszámítani.',
	'aggregateTypeToggler': 'Összesítési típus megjelenítése',
	'maxColumnsExceeded': 'Túllépte az oszlopok maximális számát. %{columns} oszlop megszüntetve.',
	'unboundColumns': 'A következő oszlopok nem használhatók: %{columns}.',
	'unboundColumn': 'A következő oszlop nem használható: %{columns}.',
	'recommendRequestFailed': 'Az ajánlás meghibásodik meghiúsult. Forduljon az adminisztrátorhoz.',
	'visualizationDoesNotSupportOLAP': 'Ezt az OLAP adatforráson alapuló megjelenítést nem tudjuk létrehozni. Használjon másik támogatott adatforrást.',
	'showDataBehindVizLabel': 'Adatok megjelenítése',
	'showDataBehindVizNotSupportedLabel': 'Az adatok megjelenítése ezen megjelenítési típus esetében nem támogatott',
	'exploreData': 'Böngészés ...',
	'newExplore': 'Új böngészés',
	'thumbnails_error_fetching': 'Hiba a miniatűrök lehívásakor',
	'loadedThumbnailImage': 'A(z) %{visType} megjelenítés miniatűr képe betöltve',
	'autobinAxisLabel': 'csoportok',
	'recommended_visualizations': 'Javasolt megjelenítések',
	'all_visualizations': 'Összes megjelenítés',
	'edit': 'Szerkesztés',
	'selectTargetDialogTitle': 'Átfúrási cél kiválasztása',
	'noTargetInCM': 'A teljes körű átfúrás célja nem található',
	'errorDrillDefinition': 'Valami hiba történt az átfúrásmeghatározás hozzáadása vagy szerkesztése során.',
	'errorDrillToTarget': 'Hiba történt lefúrás közben a következőre: \'%{targetName}\'',
	'drillThroughMappingViewLabel': 'Oszlopok hozzárendelése a műszerfalról a cél jelentés adatbekérőihez',
	'drillthroughScopeRadioLabel': 'A meghatározás alkalmazása a következőre:',
	'drillthroughScopeRadioOptionVisualization': 'Csak ez a megjelenítés',
	'drillthroughScopeRadioOptionConnection': 'Azonos adatforrást használó ugyanazon kapcsolatban található megjelenítések',
	'drillthroughScopeRadioOptionDashboard': 'A(z) %{perspective} perspektíván lévő azonos adatforrást használó megjelenítések',
	'drillThroughParametersColumnTitle': '\'%{targetName}\' adatbekérők:',
	'drillThroughMetadataColumnTitle': '\'%{boardName}\' adatoszlopok:',
	'drillThroughDefinitionNoParameter': 'Az átfúrási célnak nincsenek adatbekérései.',
	'drillThroughDefinitionErrorQueryingReport': 'Javítsa ki a cél jelentés problémáját, majd próbálja újra létrehozni az átfúrásmeghatározást.',
	'drillThroughDefinitionErrorDlgTitle': 'Hiba történt',
	'dlg_back': 'Vissza',
	'dlg_close': 'Bezárás',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Mégse',
	'dlg_apply': 'Alkalmaz',
	'drillthrough_unsaveMsg': 'Folytatja a(z) \'%{name}\' mentése nélkül?',
	'drillthrough_jumpTo': 'Átfúrásmeghatározás: %{name}',
	'drillthrough_jumpToLabel': 'Teljes körű átfúrás',
	'drillthrough_manage': 'Kezelés...',
	'drillthrough_addNewTarget': 'Új teljes körű átfúrásmeghatározás hozzáadása',
	'drillthrough_manageJumpPaths': 'Átfúrásmeghatározások kezelése',
	'drillthrough_manageJumpPaths_edit': '\'%{name}\' szerkesztése',
	'drillthrough_manageJumpPaths_delete': '\'%{name}\' törlése',
	'drillthrough_manageAddAnotherTarget': 'Másik átfúrásmeghatározás hozzáadása',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Törlés megerősítése',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Biztosan törli a(z) \'%{name}\' átfúrást?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Duplán szereplő átfúrásnév',
	'drillthrough_definitionMessage': 'A(z) \'%{name}\' átfúrás már létezik. Adjon meg egy másik nevet',
	'drillthrough_jumpToTarget_notFound': 'A(z) \'%{name}\' átfúrási cél nem található',
	'drillThroughDefinitionNoParameterSubTitle': 'Nem lesz átadva kontextus a céljelentésnek.',
	'drillthrough_titleLabel': 'Cím',
	'drillthrough_subTitle': 'A forrás megjelenítésének kontextusa a(z) %{perspective} cél szűrésére szolgál.',
	'noPrompt': 'Nincs adatbekérő',
	'formatAutoDescription': 'Az Auto az adatforrásból vagy megjelenítésből örökölt formátumot határozza meg.',
	'formatDefaultDescription': 'Az Alapértelmezett a rendszertől örökölt formátumot határozza meg',
	'createCustomGroupAction': 'Adatcsoport létrehozása',
	'removeCustomGroupAction': 'Adatcsoport eltávolítása',
	'editCustomGroupAction': 'Adatcsoport szerkesztése',
	'renameCustomGroupAction': 'Adatcsoport átnevezése',
	'createCustomGroupErrorToast': 'Az adatcsoport nem hozható létre.',
	'removeCustomGroupErrorToast': 'Az adatcsoport nem távolítható el.',
	'editCustomGroupErrorToast': 'Az adatcsoport nem szerkeszthető.',
	'renameCustomGroupErrorToast': 'Az adatcsoport nem átnevezhető.',
	'customGroupLabel': 'Adatcsoport',
	'ungroupCustomGroupLabel': 'Csoportbontás',
	'renameCustomGroupLabel': 'Átnevezés',
	'createCustomGroupLabel': 'Létrehozás',
	'customGroupingLabel': '%{columnLabel} (Csoport)',
	'createCustomSort': 'Egyéni rendezés létrehozása',
	'createCustomSortTitle': '%{createCustomSort}: %{name}',
	'createCustomSortDesc': 'Válassza ki a rendelkezésre álló elemeket, majd egyéni rendezéssel rendezze újra őket.',
	'availableItems': 'Rendelkezésre álló elemek',
	'selectAll': '(Összes kiválasztása)',
	'customSortOrder': 'Egyéni rendezési sorrend',
	'selectAvailableItemsDesc': 'Válassza ki a rendelkezésre álló elemeket, majd itt rendezze újra őket.',
	'moveToTop': 'Áthelyezés felülre',
	'clear': 'Törlés',
	'sortRemainingItemsBy': 'Fennmaradó elemek rendezési szempontja',
	'clearAll': 'Az összes törlése',
	'resetTooltip': 'A(z) %{customSortOrder} listából minden elem eltávolításra kerül. És a(z) %{sortRemainingItemsBy} legördülő lista visszaáll az alapértelmezésre.',
	'manyItemsWarning': 'Sok elem kijelölése hatással lehet műszerfala teljesítményére.',
	'manyItemsSelected': 'Több, mint %{maxItems} elem került kijelölésre, ez hatással lehet műszerfala teljesítményére.',
	'somethingWentWrong': 'Hiba történt',
	'unableToLoadItems': 'A rendelkezésre álló elemek nem tölthetők be.',
	'tryAgain': 'Ismételt próbálkozás',
	'customSortLabel': 'Egyéni rendezés',
	'applyError': 'A(z) %{action} nem alkalmazható.',
	'searchReturnedNoResults': 'A keresés nem adott vissza találatokat',
	'tryDifferentSearchTerm': 'Próbálkozzon egy másik keresési kifejezéssel',
	'extVisSystem': 'Rendszer',
	'extVisCustom': 'Egyéni',
	'customVisTestVisualization': 'Megjelenítés tesztelése',
	'extVisCustomVisPreview': 'előnézet',
	'extVisCustomPreviewWidgets': 'Fejlesztői felületi elemek',
	'extVisCustomVVisualization': 'Megjelenítés',
	'extVisCustomVisuals': 'Egyéni megjelenítések',
	'noPermissionToManage': 'Nem jogosult egyéni megjelenítések kezelésére.',
	'extVisCustomUpdate': 'Frissítés',
	'extVisCustomDelete': 'Törlés',
	'extVisNoCustomVisuals': 'Nincsenek egyéni vizuális elemek',
	'extVisNoCustomVisualsMsg': 'Szervezeténél jelenleg nincsenek egyéni képek',
	'extVisAddCustomVisual': 'Egyéni kép hozzáadása',
	'extVisNoCustomVisualsAdminMsg': 'Jelenleg nincsenek egyéni képek. A kezdéshez adjon hozzá egyet',
	'extVisNoSDKConnection': 'Nem jött létre kapcsolat a helyi fájlhoz',
	'extVisNoSDKPreviewMsg': 'A megjelenítések előnézetéhez hozzon létre kapcsolatot.',
	'extVisMore': 'Továbbiak',
	'extVisDeleteDialogTitle': 'Egyéni kép törlése',
	'extVisDeleteDialogBody': 'Biztosan törli ezt az egyéni megjelenítést? Lehet, hogy más műszerfalak vagy jelentések még használják.',
	'extVisDeleteConfirmation': 'Az egyéni vizuális elem törlésre került.',
	'extVisDeleteError': 'Az egyéni vizuális elem nem törölhető. %{msg}',
	'extVisCloseToast': 'Bezárás most',
	'extVisAdd': 'Az egyéni vizuális elem sikeresen hozzáadásra került.',
	'extVisAddError': 'Az egyéni vizuális elem nem adható hozzá. %{msg}',
	'extVisUpdate': 'Az egyéni vizuális elem sikeresen frissítésre került.',
	'extVisUpdateError': 'Az egyéni vizuális elem nem frissíthető. %{msg}',
	'extVisAddProgress': '%{name} importálása',
	'extVisUpdateProgress': '%{name} frissítése',
	'extPermissionTitle': 'Korlátozott hozzáférés vagy törölt egyéni vizuális elem',
	'extPermissionBody': 'Ez az egyéni vizuális elem nem jeleníthető meg, mert vagy törölt, vagy korlátozott hozzáféréssel rendelkezik.',
	'customVizSaveWarning': 'Az egyéni vizuális elemeket nem  lehet menteni. Nem lettek importálva.',
	'schematicTestCaption': 'Tervrajz tesztelése',
	'schematicServiceRequestError': 'Tervrajzszolgáltatás hiba',
	'extVisPreviewMessage': 'Ez egy előkép. A megjelenítés még nem lett hozzáadva a termékhez.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Meghatározatlan',
	'kpiDefaultTargetLabel': 'Cél',
	'kpiNonNumericTarget': 'A cél értéke csak szám lehet.',
	'kpiManualTargetSlotFilled': 'A mezőben alkalmazott érték',
	'kpiAutoValueSize': 'Automatikus',
	'kpiUnableDrawSparklineLabel': 'Nem lehet értékgörbét rajzolni',
	'kpiUnableDrawSparklineInfo': 'Az értékgörbéhez legalább két időbeli pontra van szükség. Az értékgörbe megtekintéséhez módosítsa az adatokat vagy állítsa be a szűrőket.',
	'conditionalFormattingEnabled': 'Feltételes szín',
	'currentConditionalPalette': 'Aktuális feltételes paletta',
	'sectionName_range': 'Tartomány beállítása',
	'rangeScaleLabel': 'Skála',
	'rangeScalePercentage': 'Százalék',
	'rangeScaleNumeric': 'Numerikus',
	'numberOfSteps': 'Tartományok száma',
	'conditionalFormattingSelectedStep': 'Kijelölt tartomány',
	'conditionalFormattingStartValue': 'Kezdőérték',
	'conditionalFormattingEndValue': 'Befejező érték',
	'conditionalFormattingTextColor': 'Szöveg színe',
	'conditionalFormattingMin': 'Min',
	'conditionalFormattingMax': 'Maximum',
	'conditionalFormattingNonNumericValue': 'Az értéknek számnak kell lennie.',
	'conditionalFormattingStepIndexInvalid': 'A tartományindex érvénytelen.',
	'conditionalFormattingValueOutOfBoundsInvalid': 'Az értéknek a következő tartományba kell esnie: %{start} - %{end}.',
	'conditionalFormattingValueShouldBeLower': 'Az érték legfeljebb %{value} lehet.',
	'conditionalFormattingValueSouldBeHigher': 'Az érték nem lehet kisebb, mint %{value}.',
	'conditionalFormattingDeleteStep': 'Kiválasztott tartomány eltávolítása',
	'conditionalFormattingRestoreSteps': 'Tartományok visszaállítása',
	'conditionalFormattingReversePalette': 'Színek megfordítása',
	'conditionalFormattingShapeIndicator': 'Jelző alakja',
	'conditionalFormattingIconNone': 'Nincs jelző',
	'conditionalFormattingIconArrowUp': 'Felfelé mutató nyíl',
	'conditionalFormattingIconArrowRight': 'Jobbra mutató nyíl',
	'conditionalFormattingIconArrowDown': 'Lefelé mutató nyíl',
	'conditionalFormattingIconCaretUp': 'Felfelé mutató kalap',
	'conditionalFormattingIconDash': 'Kötőjel',
	'conditionalFormattingIconCaretDown': 'Lefelé mutató kalap',
	'conditionalFormattingIconCheckmark': 'Pipa',
	'conditionalFormattingIconWarning': 'Figyelmeztetés',
	'conditionalFormattingIconXSymbol': 'X szimbólum',
	'conditionalFormattingIconCircle': 'Kör',
	'conditionalFormattingIconTriangle': 'Háromszög',
	'conditionalFormattingIconDiamond': 'Rombusz',
	'conditionalFormattingIconFaceSatisfied': 'Elégedett arc',
	'conditionalFormattingIconFaceNeutral': 'Semleges arc',
	'conditionalFormattingIconFaceDissatisfied': 'Elégedetlen arc',
	'suppression': 'Elnyomás',
	'suppressNone': 'Nincs',
	'suppressRowsAndColumns': 'Sorok és oszlopok.',
	'suppressRows': 'Sorok',
	'suppressColumns': 'Oszlopok',
	'enableSuppression': 'Elnyomás engedélyezése',
	'disableSuppression': 'Elnyomása letiltása',
	'loadVisDefinitionError': 'A következő megjelenítés meghatározása nem tölthető be: %{id}',
	'emptyVisualization': 'Üres megjelenítés',
	'expandCollapse': 'Kibontás és összehúzás',
	'expandBtnLabel': 'Kibontás',
	'collapseBtnLabel': 'Visszazárás',
	'prop_sizeInputNonNumericValue': 'Az értéknek számnak kell lennie.',
	'prop_sizeValueShouldBeHigher': 'Az értéknek nagyobbnak kell lennie, mint %{value}.',
	'fontPropLabel': 'Betűtípuscsalád',
	'fontSizePropLabel': 'Betűméret',
	'sectionItemAxisTitle': 'Elem tengely címe',
	'sectionItemAxisLabel': 'Elem tengely címkéje',
	'sectionValueAxisTitle': 'Érték tengely felirata',
	'sectionValueAxisLabel': 'Érték tengely címkéje',
	'fontFamily': 'family',
	'fontSize': 'size',
	'visExportFileName': 'Megjelenítés',
	'ds-missingDataSet': 'Nem található adathalmaz. Győződjön meg róla, hogy az adathalmaz sikeresen létrehozásra került.',
	'ds-missingDashboardId': 'Az adathalmaz létrehozása előtt mentse a műszerfalat.',
	'ds-unsupportedDataSourceType': 'A(z) %{type} adatforrástípus nem támogatott.'
});
